import {
    FaMapMarkerAlt,
    FaPhoneAlt,
    FaEnvelope,
    FaClock,
    FaFacebookF,
    FaInstagram,
    FaYoutube
} from "react-icons/fa";

import "../../assets/css/contactInfo.css";

function ContactInfo() {

    return (

        <section className="customer-contact-info">

            <h2 className="customer-contact-info-title">
                Get In Touch
            </h2>

            <p className="customer-contact-info-subtitle">
                We would love to hear about your upcoming celebration.
                Contact Story Line Studios and let us turn your special
                moments into timeless memories.
            </p>

            {/* Address */}

            <div className="customer-contact-info-card">

                <div className="customer-contact-info-icon">
                    <FaMapMarkerAlt />
                </div>

                <div className="customer-contact-info-content">

                    <h3>Studio Address</h3>

                    <p>
                        Khammam,<br />
                        Telangana,<br />
                        India
                    </p>

                </div>

            </div>

            {/* Phone */}

            <div className="customer-contact-info-card">

                <div className="customer-contact-info-icon">
                    <FaPhoneAlt />
                </div>

                <div className="customer-contact-info-content">

                    <h3>Phone</h3>

                    <p>

                        <a href="tel:+919000306722">
                           +91 9000306722
                        </a>

                    </p>

                </div>

            </div>

            {/* Email */}

            <div className="customer-contact-info-card">

                <div className="customer-contact-info-icon">
                    <FaEnvelope />
                </div>

                <div className="customer-contact-info-content">

                    <h3>Email</h3>

                    <p>

                        <a href="mailto:storylinestudios@gmail.com">
                            storylinestudios@gmail.com
                        </a>

                    </p>

                </div>

            </div>

            {/* Working Hours */}

            <div className="customer-contact-info-card">

                <div className="customer-contact-info-icon">
                    <FaClock />
                </div>

                <div className="customer-contact-info-content">

                    <h3>Working Hours</h3>

                    <div className="customer-contact-hours">

                        <span>Monday - Saturday</span>

                        <strong>9:00 AM - 7:00 PM</strong>

                    </div>

                    <div className="customer-contact-hours">

                        <span>Sunday</span>

                        <strong>By Appointment</strong>

                    </div>

                </div>

            </div>

            {/* Social */}

            <div className="customer-contact-social">

                <h3>Follow Us</h3>

                <div className="customer-contact-social-icons">

                    <a
    href="https://facebook.com/storylinestudios"
    target="_blank"
    rel="noopener noreferrer"
>
    <FaFacebookF />
</a>

<a
    href="https://instagram.com/storylinestudios"
    target="_blank"
    rel="noopener noreferrer"
>
    <FaInstagram />
</a>

<a
    href="https://youtube.com/@storylinestudios"
    target="_blank"
    rel="noopener noreferrer"
>
    <FaYoutube />
</a>

                </div>

            </div>

        </section>

    );

}

export default ContactInfo;